import type { BBox } from 'geojson'

import LanguageModel from './LanguageModel.ts'

type CoordinateType = { latitude: number; longitude: number }

class RegionModel {
  _name: string
  _code: string
  _live: boolean
  _languages: LanguageModel[]
  _chatEnabled: boolean
  _chatPrivacyPolicyUrl: string | null
  _eventsEnabled: boolean
  _placesEnabled: boolean
  _localNewsEnabled: boolean
  constructor(params: {
    name: string
    code: string
    live: boolean
    languages: LanguageModel[]
    placesEnabled: boolean
    eventsEnabled: boolean
    localNewsEnabled: boolean
    externalNewsEnabled: boolean
    chatEnabled: boolean
    sortingName: string
    prefix: string | null
    latitude: number
    longitude: number
    aliases: Record<string, CoordinateType> | null
    boundingBox: BBox
    chatPrivacyPolicyUrl: string | null
  }) {
    this._name = params.name
    this._code = params.code
    this._live = params.live
    this._languages = params.languages
    this._chatEnabled = params.chatEnabled
    this._eventsEnabled = params.eventsEnabled
    this._placesEnabled = params.placesEnabled
    this._localNewsEnabled = params.localNewsEnabled
    this._externalNewsEnabled = params.externalNewsEnabled
    this._sortingName = params.sortingName
    this._prefix = params.prefix
    this._latitude = params.latitude
    this._longitude = params.longitude
    this._aliases = params.aliases
    this._boundingBox = params.boundingBox
    this._chatPrivacyPolicyUrl = params.chatPrivacyPolicyUrl
  }
  _sortingName: string
  _prefix: string | null
  _latitude: number
  _longitude: number

  _externalNewsEnabled: boolean

  _boundingBox: BBox

  get boundingBox(): BBox {
    return this._boundingBox
  }

  get live(): boolean {
    return this._live
  }

  get name(): string {
    return this._name
  }

  get languages(): LanguageModel[] {
    return this._languages
  }

  get code(): string {
    return this._code
  }

  get sortingName(): string {
    return this._sortingName
  }

  get chatEnabled(): boolean {
    return this._chatEnabled
  }

  get eventsEnabled(): boolean {
    return this._eventsEnabled
  }

  get placesEnabled(): boolean {
    return this._placesEnabled
  }

  get localNewsEnabled(): boolean {
    return this._localNewsEnabled
  }

  get externalNewsEnabled(): boolean {
    return this._externalNewsEnabled
  }

  get newsEnabled(): boolean {
    return this._localNewsEnabled || this._externalNewsEnabled
  }

  get sortCategory(): string {
    return this._sortingName.charAt(0)
  }

  get prefix(): string | null {
    return this._prefix
  }

  get longitude(): number {
    return this._longitude
  }

  get latitude(): number {
    return this._latitude
  }

  get chatPrivacyPolicyUrl(): string | null {
    return this._chatPrivacyPolicyUrl
  }

  _aliases: Record<string, CoordinateType> | null

  get aliases(): Record<string, CoordinateType> | null {
    return this._aliases
  }

  static findRegionName(regions: readonly RegionModel[], code: string): string {
    const region = regions.find(region => region.code === code)
    return region ? region.name : code
  }
}

export default RegionModel
